import { camelize } from './common';

export enum ContentTypes {
  jsonDefault = 'application/json',
  json = 'application/json; charset=utf-8',
  vndJson = 'application/vnd.s.v1+json; charset=utf-8',
  vndJsonLegacy = 'application/vnd.softswiss.v1+json; charset=utf-8',
  vndJsonV2 = 'application/vnd.s.v2+json; charset=utf-8',
  vndJsonV2Legacy = 'application/vnd.softswiss.v2+json; charset=utf-8',
}

const contentTypes = [
  ContentTypes.jsonDefault,
  ContentTypes.json,
  ContentTypes.vndJson,
  ContentTypes.vndJsonLegacy,
  ContentTypes.vndJsonV2,
  ContentTypes.vndJsonV2Legacy,
];

export function getResponseCamelization(
  data: any,
  headers?: Headers,
  blacklists?: string[][]
): any {
  if (
    headers != null &&
    headers.has('content-type') &&
    contentTypes.includes(headers.get('content-type') as ContentTypes)
  ) {
    let jsonResp;

    if (typeof data === 'string') {
      try {
        jsonResp = JSON.parse(data);
      } catch (err) {
        console.error(err);
      }
    } else {
      jsonResp = data;
    }

    return camelize(jsonResp, blacklists);
  }

  return data;
}
